var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferralIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "3 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_7588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C21.38 12 19.25 14.13 19.25 16.75C19.25 19.32 21.26 21.4 23.88 21.49C23.96 21.48 24.04 21.48 24.1 21.49C24.12 21.49 24.13 21.49 24.15 21.49C24.16 21.49 24.16 21.49 24.17 21.49C26.73 21.4 28.74 19.32 28.75 16.75C28.75 14.13 26.62 12 24 12Z",
    fill: "#3E474F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.93 24.1499C21.74 22.2899 26.29 22.2899 29.08 24.1499C30.34 24.9899 31.03 26.1299 31.04 27.3599C31.04 28.5999 30.34 29.7399 29.08 30.5899C27.68 31.5299 25.84 31.9999 24 31.9999C22.16 31.9999 20.32 31.5299 18.92 30.5899C17.66 29.7499 16.96 28.6099 16.96 27.3799C16.96 26.1499 17.66 24.9999 18.93 24.1499ZM24.75 26.6299H26C26.41 26.6299 26.75 26.9699 26.75 27.3799C26.75 27.7899 26.41 28.1299 26 28.1299H24.75V29.3799C24.75 29.7899 24.41 30.1299 24 30.1299C23.59 30.1299 23.25 29.7899 23.25 29.3799V28.1299H22C21.59 28.1299 21.25 27.7899 21.25 27.3799C21.25 26.9699 21.59 26.6299 22 26.6299H23.25V25.3799C23.25 24.9699 23.59 24.6299 24 24.6299C24.41 24.6299 24.75 24.9699 24.75 25.3799V26.6299Z",
    fill: "#5ED5A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_7588",
    x: 0.959961,
    y: 1,
    width: 46.0801,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.835294 0 0 0 0 0.658824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_7588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_7588",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralIcon);
export default __webpack_public_path__ + "static/media/referralIcon.8d37ad40378871faa1ed581de91bee5a.svg";
export { ForwardRef as ReactComponent };